import { render, staticRenderFns } from "./suporte-atualizacao-de-pdf.vue?vue&type=template&id=78b7eaeb"
import script from "./suporte-atualizacao-de-pdf.vue?vue&type=script&lang=ts"
export * from "./suporte-atualizacao-de-pdf.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports